import React from 'react'

export default function WelcomePage() {
return (
<div className="h-screen w-full bg-[#042739] text-white flex flex-col items-center justify-center p-10 relative">
<div className="absolute top-10 right-20 w-40 h-40 rounded-full bg-blue-500/10 blur-2xl"></div>
<div className="absolute bottom-10 left-20 w-40 h-40 rounded-full bg-green-500/10 blur-2xl"></div>


<h1 className="text-7xl font-bold mb-4">Welcome</h1>
<p className="text-lg max-w-xl text-center opacity-80 mb-10">
A next-generation engine designed to create accurate, challenging, and insightful financial quizzes.
</p>


<div className="flex gap-4">
<button className="px-10 py-3 bg-blue-500 rounded-xl hover:bg-blue-600 transition">Login</button>
<button className="px-10 py-3 bg-green-500 rounded-xl hover:bg-green-600 transition">Sign Up</button>
</div>
</div>
);
}